module.exports = __webpack_public_path__ + "img/sunshine-promo.2193995a.png";